import { useEffect } from "react";
import { useSocket } from "../context/SocketProvider";

const WebSocketHandler = () => {
  const { socket } = useSocket();

  useEffect(() => {
    if (socket) {
      ////console.log("WebSocket connected:", socket);

      socket.emit("message", "Hello Server");

      const handleResponse = (data) => {
        ////console.log("Received from server:", data);
      };

      socket.on("processing_complete", handleResponse);

      return () => {
        socket.off("processing_complete", handleResponse);
      };
    }
  }, [socket]);

  return null;
};

export default WebSocketHandler;
